import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import ErrorBoundary from './components/ErrorBoundary'
import Home from './pages/Home'
import Membership from './pages/Membership'
import Pool from './pages/Pool'
import Tennis from './pages/Tennis'
import FacilityReservation from './pages/FacilityReservation'
import Events from './pages/Events'
import EventDetail from './pages/EventDetail'
import AboutUs from './pages/AboutUs'
import PhotoGallery from './pages/PhotoGallery'
import BoardMinutes from './pages/BoardMinutes'
import Sponsors from './pages/Sponsors'
import Rules from './pages/Rules'
import Contact from './pages/Contact'
import ManageBooking from './pages/ManageBooking'
import Login from './pages/Login'
import AdminDashboard from './admin/AdminDashboard'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Public Routes */}
          <Route index element={<Home />} />
          <Route path="membership" element={<Membership />} />
          <Route path="pool" element={<Pool />} />
          <Route path="tennis" element={<Tennis />} />
          <Route path="facility-reservation" element={<FacilityReservation />} />
          <Route path="events" element={<Events />} />
          <Route path="events/:id" element={<EventDetail />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="photo-gallery" element={<PhotoGallery />} />
          <Route path="sponsors" element={<Sponsors />} />
          <Route path="board-minutes" element={<BoardMinutes />} />
          <Route path="rules" element={<Rules />} />
          <Route path="contact" element={<Contact />} />
          <Route path="manage-booking" element={<ManageBooking />} />
          <Route path="login" element={<Login />} />
        </Route>

        {/* Protected Admin Routes - Outside Layout for full-screen control */}
        <Route
          path="admin/*"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </ErrorBoundary>
  )
}

export default App
